import clsx from 'clsx';
import styles from './negotiation-listings-modal-skeleton.module.scss';

const NegotitationListingsModalSkeleton = () => {
  return (
    <div className="scc">
      {/* 
      //Add a comment here, in case someday, the title of the modal will be dynamic 
      <div className={styles.negotiation__title}>
        <div className={clsx("ssc-head-line w-50", styles.negotiation__title__w50)}></div>
      </div> 
      */}
      <div className={styles.negotiation__product__wrapper}>
        <div className={styles.negotiation__product__img}>
          <div className="ssc-square"></div>
        </div>
        <div className={styles.negotiation__productInfo}>
          <div className={clsx('ssc-line', styles.negotiation__productInfo__h24)}></div>
          <div className={clsx('ssc-line', styles.negotiation__productInfo__h24)}></div>
          <div className={clsx('ssc-line', styles.negotiation__productInfo__h24)}></div>
          <div className={clsx('ssc-line', styles.negotiation__productInfo__h20)}></div>
        </div>
      </div>
      <div className={clsx('ssc-line', styles.negotiation__status)}></div>
    </div>
  );
};

export default NegotitationListingsModalSkeleton;
